import { render, staticRenderFns } from "./InIcon.vue?vue&type=template&id=074893c4&scoped=true&"
import script from "./InIcon.vue?vue&type=script&lang=js&"
export * from "./InIcon.vue?vue&type=script&lang=js&"
import style0 from "./InIcon.vue?vue&type=style&index=0&id=074893c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074893c4",
  null
  
)

export default component.exports